import type {Routes} from '@angular/router'
import {LoginGuardService} from '@pages/login/login.guard.service'

const APP_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('@pages/login/login.page').then(m => m.LoginPage),
    canActivate: [LoginGuardService],
    data: {
      checkIntervalGPS: false,
    },
  },
  {
    path: 'home',
    loadChildren: () => import('@pages/home/home.routes'),
  },
  {
    path: 'activities',
    loadChildren: () => import('@pages/activities/activities.routes'),
  },
  {
    path: 'reports',
    loadChildren: () => import('@pages/reports/reports.routes'),
  },
  {
    path: 'gallery-cloud',
    loadChildren: () => import('@pages/gallery/gallery.routes'),
  },
  {
    path: 'schedule',
    loadChildren: () => import('@pages/schedule/schedule.routes'),
  },
  {
    path: 'sync',
    loadChildren: () => import('@pages/sync/sync.routes'),
  },
  {
    path: 'new-outlet',
    loadChildren: () => import('@pages/new-outlet/new-outlet.routes'),
  },
  {
    path: 'user-configuration',
    loadChildren: () => import('@pages/user-configuration/user-configuration.routes'),
  },
  {
    path: 'general-debts',
    loadChildren: () => import('@pages/general-debts/general-debts.routes'),
  },
  {
    path: 'general-debts-detail',
    loadChildren: () => import('@pages/general-debts-detail/general-debts-detail.routes'),
  },
  {
    path: 'general-payments',
    loadChildren: () => import('@pages/general-payments/general-payments.routes'),
  },
  {
    path: 'closing-day-tabs',
    loadChildren: () => import('@pages/closing-day-tabs/closing-day-tabs.routes'),
  },
  {
    path: 'outlet-detail',
    loadChildren: () => import('@pages/outlet-detail/outlet-detail.routes'),
  },
  {
    path: 'orders',
    loadChildren: () => import('@pages/orders/orders.routes'),
  },
  {
    path: 'order-detail',
    loadChildren: () => import('@pages/order-detail/order-detail.routes'),
  },
  {
    path: 'test-recovery-data',
    loadChildren: () => import('@pages/test-recovery-data/test-recovery-data.routes'),
  },
  {
    path: 'tables-management',
    children: [
      {
        path: '',
        loadChildren: () => import('@pages/general-tables-management/general-tables-management.routes'),
      },
      {
        path: ':id',
        loadChildren: () => import('@pages/table-management-details/table-management-details.routes'),
      },
    ],
  },
  {
    path: 'report-kpi-details',
    loadChildren: () => import('@pages/report-kpi-details/report-kpi-details.routes'),
  },
  {
    path: 'stocks',
    loadChildren: () => import('@pages/stocks/stocks.routes'),
  },
  {
    path: 'embedded-standby',
    loadChildren: () => import('@pages/standby-embedded/standby-embedded.routes'),
  },
  {
    path: 'promotional-packs',
    loadChildren: () => import('@pages/promotional-packs/promotional-packs.routes'),
  },
  {
    path: 'gallery',
    redirectTo: 'gallery-cloud',
    pathMatch: 'full',
  },
  {
    path: 'echo',
    loadChildren: () => import('@features/echo/echo.routes'),
  },
]
export default APP_ROUTES
